import PropTypes from 'prop-types';
import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import Dropdown, { alignConstants, sizeConstants } from '../Dropdown/Dropdown';

import VipAccountContent from './VipAccountContent';
import styles from './VipAccountManagerLink-style.scss';

const vipLink = (
    <div className={styles.link}>
        <FormattedMessage
            id="dbl.Header.BottomBar.vipAccountManagerLink.link"
            defaultMessage="Client Services"
        />
    </div>
);

export class VipAccountManagerLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fragmentVariables: {
                fetchRep: false,
                userIds: this.props.userIds || [],
            },
        };

        this.triggerRepFetch = this.triggerRepFetch.bind(this);
    }

    triggerRepFetch() {
        const { hasRootPendingRefetch, hasUserId, userIds } = this.props;

        if (hasRootPendingRefetch) {
            return;
        }
        if (!this.state.fragmentVariables.fetchRep) {
            this.setState(
                {
                    fragmentVariables: {
                        ...this.state.fragmentVariables,
                        fetchRep: hasUserId,
                        userIds,
                    },
                },
                () => {
                    this.props.relay.refetch(this.state.fragmentVariables, null);
                }
            );
        }
    }

    render() {
        const { viewer } = this.props;

        return (
            <Dropdown
                align={alignConstants.ALIGN_RIGHT}
                size={sizeConstants.SIZE_SMALL}
                className={styles.wrapper}
                onShow={this.triggerRepFetch}
            >
                {vipLink}
                <VipAccountContent userRelationships={viewer.userRelationships} />
            </Dropdown>
        );
    }
}

VipAccountManagerLink.propTypes = {
    hasRootPendingRefetch: PropTypes.bool,
    hasUserId: PropTypes.bool,
    isClient: PropTypes.bool,
    relay: PropTypes.object,
    userIds: PropTypes.array,
    viewer: PropTypes.object,
};

VipAccountManagerLink.defaultProps = {
    hasRootPendingRefetch: false,
    hasUserId: false,
    isClient: false,
    userIds: [],
};

export default createRefetchContainer(
    VipAccountManagerLink,
    {
        viewer: graphql`
            fragment VipAccountManagerLink_viewer on Viewer
                @argumentDefinitions(fetchRep: { type: "Boolean!", defaultValue: false }) {
                userRelationships(userIds: $userIds, relationshipType: VIP)
                    @include(if: $fetchRep) {
                    userDataB {
                        ... on VipRepData {
                            displayName
                            phoneNumber(formatType: INTERNATIONAL)
                            email
                        }
                    }
                }
            }
        `,
    },
    graphql`
        query VipAccountManagerLinkRefetchQuery($userIds: [String]!, $fetchRep: Boolean!) {
            viewer {
                ...VipAccountManagerLink_viewer @arguments(fetchRep: $fetchRep)
            }
        }
    `
);
